/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { gql } from '@apollo/client';
import { object, shape, string } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import SmartGiftShopBlock from './SmartGiftShopBlock';
import { GRAPHQL_ENV } from '../../../gql';
import * as app from '../../../../state/ducks/App';

const brandSelectors = app?.ducks?.brand?.selectors;

const SmartGiftShopPage = ({ brand, page }) => {
    const path = page ? page.path : '';
    const Smart_Gift_PAGE_QUERY = gql`
            query SmartGiftShopPage {
                findSmartGiftPage(brand: "${brand['domain-name']}", url: "${path}",environment: "${GRAPHQL_ENV}", locale: "en-us") {
                    content
                    productSkus {
                        id
                        name
                        image {
                          name
                          path
                        }
                        parentProduct {
                          name
                        }
                      }
                }
            }
        `;

    return (
        <Query query={Smart_Gift_PAGE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: Smart_Gift_PAGE_QUERY,
                        component: 'SmartGiftShopPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: Smart_Gift_PAGE_QUERY,
                        component: 'SmartGiftShopPage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                const blocks = data?.findSmartGiftPage?.content?.entries?.[0] || null;
                const productSkus = data?.findSmartGiftPage?.productSkus || null;
                if (blocks !== null) {
                    return (
                        <>
                            <SmartGiftShopBlock data={blocks} productSkus={productSkus} />
                        </>
                    );
                }
                return null;
            }}
        </Query>
    );
};

SmartGiftShopPage.propTypes = {
    brand: object.isRequired,
    page: shape({
        contentType: string.isRequired,
        path: string.isRequired,
    }).isRequired,
};
const mapStateToProps = (state) => ({
    brand: brandSelectors?.getBrand(state),
});

export default withRouter(connect(mapStateToProps)(SmartGiftShopPage));
